import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export function useCircleBanStatus() {
  const { userId } = useAuth();

  const { data: ban, isLoading } = useQuery({
    queryKey: ["circle-ban-status", userId],
    queryFn: async () => {
      if (!userId) return null;

      const { data, error } = await supabase
        .from("circle_bans")
        .select("*")
        .eq("user_id", userId)
        .is("unbanned_at", null)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!userId,
  });

  return {
    ban,
    isLoading,
    isBanned: !!ban,
    banReason: ban?.reason || null,
  };
}
